module.exports = __webpack_public_path__ + "img/client_logo_8.e76ffd8a.png";